import { BACKEND_URL } from "@/lib/constants/constants";

import axios from "../custom/axiosConfig";

export const generateInvoicesAndTransactionsForReconciliation = async (
  invoiceCount: number,
) => {
  const response = await axios<{ response: string; images: string[] }>({
    method: "post",
    url: `${BACKEND_URL}/developer-tools/generate-invoices-and-transactions-for-reconciliation`,
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      invoiceCount,
    },
  });

  return response?.data?.response;
};

export const createTransactionsFromCsv = async (csvFile: File) => {
  const formData = new FormData();
  formData.append("file", csvFile);

  const response = await axios<{
    message: string;
    transactionsCreated: number;
  }>({
    method: "post",
    url: `${BACKEND_URL}/developer-tools/create-transactions-from-csv`,
    headers: {},
    data: formData,
  });

  return response?.data;
};

export const clearBankBookings = async (bankTxnId: string) => {
  const response = await axios<{
    message: string;
  }>({
    method: "post",
    url: `${BACKEND_URL}/developer-tools/clear-bank-bookings`,
    data: {
      bankTxnId,
    },
  });

  return response?.data;
};

export enum ReconRule {
  SORT_OUT = "sortOut",
  AMOUNT_REFERENCE = "amountReference",
  BATCH_PAYMENT = "batchPayment",
  SUPPLIER_MATCH = "supplierMatch",
  AMOUNT = "amount",
  AI_CONFIRMATION = "aiConfirmation",
  AI_RECON = "aiRecon",
  USER_MATCH = "userMatch",
}

export type MatchScenario =
  | "exact"
  | "discount_1"
  | "discount_2"
  | "discount_3"
  | "foreign_currency";

interface CreateSuggestedAttachmentBody {
  scenario?: MatchScenario;
  transactionAmountCents?: number;
  invoiceCurrency?: string;
  confidence?: 0 | 1;
  rule?: ReconRule;
  supplierName?: string;
}

export const createSuggestedAttachment = async (
  body: CreateSuggestedAttachmentBody,
) => {
  const response = await axios<{
    message: string;
  }>({
    method: "post",
    url: `${BACKEND_URL}/developer-tools/create-suggested-attachment`,
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
  });

  return response?.data;
};
